import { useState, useEffect } from 'react';
import { ReqEnum } from 'const/requestStatus';
import { reqStatus } from '../types/orderTypes';
import { CourierScore, fetchCouriersScore } from '../fetch/CourierScore';
import { log } from './useFetchCouriers';

export function useFetchCouriersScore(start: string, end: string): any[] {
  const [fetchStatus, setFetchStatus] = useState<reqStatus>(ReqEnum.INIT);
  const [couriersScore, setCouriersScore] = useState<CourierScore>(null);

  useEffect(() => {
    log('Reset state');
    setFetchStatus(ReqEnum.PENDING);
    log('Fetching couriers rating');

    const fetchCouriersRatingMethod = async () => {
      const couriersScore: CourierScore = await fetchCouriersScore(start, end);

      log('Fetched score for courier');
      setCouriersScore(couriersScore);
      setFetchStatus(ReqEnum.SUCCESS);
    };
    fetchCouriersRatingMethod();
  }, [end, start]);

  return [couriersScore, fetchStatus];
}
